import {aPhraseKey, qPhraseKey} from './types';

export const QUESTION_MESSAGE_IDS: (qPhraseKey | aPhraseKey)[] = [
    'questionOne',
    'questionTwo',
    'questionThree',
    'questionFour'
];
